import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "tollsFilled"
const TollsFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M18.694 2.125C19.133 1.685 19.845 1.685 20.284 2.125L21.875 3.715C22.315 4.156 22.315 4.868 21.875 5.307L7.556 19.626 7.5 19.675V20.626H21.75V22.125H2.25V12.375C2.25 11.545 2.922 10.875 3.75 10.875H6C6.828 10.875 7.5 11.545 7.5 12.375V13.318zM8.352 14.587 9.412 15.648 11.004 14.057 9.943 12.997zM13.125 9.815 14.185 10.875 15.776 9.285 14.716 8.223zM17.898 5.04 18.958 6.101 20.55 4.512 19.489 3.451z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default TollsFilledIcon
